import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyImport, LazyAction } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "FeedbackCommon"*/ './lazyIndex'),
    { name: 'FeedbackCommon' }
);

export { LogType } from './schema/LogType';

export const CaptureFeedbackDatapoint: LazyImport<
    typeof lazyIndex.captureFeedbackDatapoint,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.captureFeedbackDatapoint);
export const lazySendFeedbackToOds: LazyImport<
    typeof lazyIndex.sendFeedbackToOds,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.sendFeedbackToOds);
export const lazySendLogsToOds: LazyAction<typeof lazyIndex.sendLogsToOds, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.sendLogsToOds);
export const lazyGetTokenForOds: LazyAction<typeof lazyIndex.getTokenForOds, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.getTokenForOds);
export { default as getPrivacyUrl } from './utils/getPrivacyUrl';

export type { OdsFeedbackOverrides } from './schema/OdsFeedbackOverrides';
